<template>
  <PanelCard v-if="visible" :title="I18n.t('user.panel.roles_title')">
    <div data-testid="user-panel-external-roles">
      <SfRadioGroup
        :model-value="store.externalRole ?? undefined"
        :options="roleOptions"
      />
    </div>
  </PanelCard>
</template>

<script setup lang="ts">
import type { SfRadioOption } from '@app/shared/vue/components/sf-radio/types'

import { computed } from 'vue'

import { EXTERNAL_ROLE_OPTION_KEYS } from '@app/application/user-management/constants'
import { useUserPanelStore } from '@app/application/user-management/stores/user-panel'
import useI18n from '@app/shared/vue/composables/use-I18n'
import PanelCard from '@app/application/user-management/components/panel-card.vue'
import SfRadioGroup from '@app/shared/vue/components/sf-radio/sf-radio-group.vue'

defineOptions({ name: 'ExternalRolesSection' })

const I18n = useI18n()
const store = useUserPanelStore()

const visible = computed(
  () => (store.user?.isActive ?? false) && store.externalRole !== null
)

// The mode is a display of what the roles already say, never a mutation:
// `user_update_params` drops `external` and `Role#unwanted_for_user?` rejects a
// new external role. So the option the user is not in is locked.
const roleOptions = computed<SfRadioOption[]>(() =>
  EXTERNAL_ROLE_OPTION_KEYS.map(({ value, label, description }) => ({
    value,
    label: I18n.t(label),
    description: I18n.t(description),
    ...(value === store.externalRole
      ? {}
      : { disabled: true, note: I18n.t('user.panel.external_role_locked') }),
  }))
)
</script>
